import { COOKIES } from "@/constants/cookies";
import { parseCookies } from "nookies";

export const useUserAuth = () => {
  function isLoggedIn() {
    return Object.prototype.hasOwnProperty.call(
      parseCookies(),
      COOKIES.BACKOFFICE_AUTH,
    );
  }

  return {
    isLoggedIn,
  };
};
